function DoBlogSearch(e) {
  var input = e.currentTarget;
  if (input.value != "") {
    ReallyDoBlogSearch(input.value);
    HandleShowAndHideBlogSearch("show");
  } else {
    HideBlogInstantSearch();
    HandleShowAndHideBlogSearch("hide");
  }
}

function ReallyDoBlogSearch(value) {
  //for more infor see:
  //https://shopify.dev/api/ajax/reference/predictive-search
  jQuery
    .getJSON("/search/suggest.json", {
      q: value,
      resources: {
        type: "article",
        limit: 10,
        options: {
          fields: "",
        },
      },
    })
    .done(function (response) {
      var articles = response.resources.results.articles;
      HideBlogInstantSearch();
      if (articles && articles.length) {
        HandlePredictiveSearchResults(articles);
      } else {
        HandlePredictiveSearchResults(
          null,
          "Sorry nothing found for <b>" + value + "</b>",
        );
      }
    });
}

function HandlePredictiveSearchResults(articles, notFoundString) {
  var predictiveBlogBody = document.querySelector(
    ".bridgman-bog-instant-search-results-container-body",
  );

  if (notFoundString) {
    var p = document.createElement("p");
    p.innerHTML = notFoundString;

    predictiveBlogBody.appendChild(p);
  } else {
    for (var i = 0; i < articles.length; i++) {
      var article = articles[i];

      var a = document.createElement("a");
      a.setAttribute("href", article.url);

      var p = document.createElement("p");
      p.innerText = article.title;

      a.appendChild(p);

      predictiveBlogBody.appendChild(a);
    }
  }
}

function HandleBlogSearch() {
  var input = document.querySelector(".blog-search");
  if (input) {
    input.addEventListener("input", DoBlogSearch);
  }
}

function HideBlogInstantSearch() {
  var parent = document.querySelector(
    ".bridgman-bog-instant-search-results-container .bridgman-bog-instant-search-results-container-body",
  );
  parent.innerHTML = "";
}

function HandleShowAndHideBlogSearch(command) {
  var target = document.querySelector(
    ".bridgman-bog-instant-search-results-container",
  );

  if (command == "show") {
    target.classList.remove("hidden");
  } else {
    target.classList.add("hidden");
  }
}

window.addEventListener("DOMContentLoaded", function () {
  HandleBlogSearch();
});

function ShowFilter(element) {
  // Get containers
  var filters = document.querySelectorAll(".advanced-filters");
  var containerShowing;
  var chosenFilter = element.querySelector(".advanced-filters");

  if (chosenFilter.style.display == "block") {
    containerShowing = true;
  } else {
    containerShowing = false;
  }

  // Loop through containers
  for (var i = 0; i < filters.length; i++) {
    // Hide all containers (filters)
    var filter = filters[i];
    filter.style.display = "none";
  }

  if (!containerShowing) {
    chosenFilter.style.display = "block";
  }
}

if ($(".collection-selected-filters").length > 0) {
  $("html, body").animate(
    {
      scrollTop:
        $("#shopify-section-bridgman-blog-sort_by").offset().top -
        $(".header-section").height(),
    },
    1000,
  );
}
function ShowFilterOnMobile(element) {
  var parent = SearchParentsFor(element, "bridgeman-filter-child");
  var container = parent.querySelector(".bridgman-mobile-sort-container");
  var containers = document.querySelectorAll(".bridgman-mobile-sort-container");
  var isShowing = false;

  if (!container.classList.contains("zero-opacity")) {
    isShowing = true;
  }

  for (var i = 0; i < containers.length; i++) {
    var con = containers[i];
    con.classList.add("zero-opacity");
  }

  if (!isShowing) {
    container.classList.remove("zero-opacity");
  } else {
    container.classList.add("zero-opacity");
  }
}
